import { defineConstants } from "@p-ban/common/src/constants/defineConstants"

const PARTICIPATE_INDIVIDUAL_CONSULTATIONS = defineConstants([
  { label: "参加", value: "Participate", isParticipate: true },
  { label: "不参加", value: "NotParticipate", isParticipate: false },
] as const)

export default PARTICIPATE_INDIVIDUAL_CONSULTATIONS
